<template>
    <div class="col-md-12 col-lg-12 col-xl-9">
        <div class="sport-menu-tabs-sec">
            <div>
               <section class="header-wrapper mt-2">
                     <div class="header-sec">
                        <div class="header-nav">
                           <div class="back-arrow">
                                 <a class="chevronLeft-btn" @click="$router.go(-1)"><i class="fa fa-chevron-left"></i></a>
                           </div>
                           <div class="header-logo">
                                 <div class="list-con header-sub-con">
                                    <h4>{{$t('withdraw','Withdraw')}}</h4>
                                 </div>
                           </div>
                        </div>
                        <div class="wallet-header-but">
                           <a class="thm-but" data-bs-toggle="modal" data-bs-target="#acc-open-model">Add Account</a>
                        </div>
                     </div>
               </section>
            </div>

            <section class="recent-wrapper walletPage-wrap">
               <div class="container">
                  <div class="payment-heading" v-if="accountsList && accountsList?.length > 0">
                     <h3>{{$t('choose-from-recent-accounts', 'Choose from recent accounts')}}</h3>
                  </div>
                  <div class="withdraw-search-account" v-if="accountsList && accountsList?.length > 0">
                     <input type="search" v-model="searchAccount" @input="searchstart()" class="form-control" placeholder="Search Account...">
                  </div>
                  <div class="paymentAccount-wrap" v-for="(item, index) in filteredAccountList" :key="index">
                     <div class="paymentAccount-item">
                        <input @click="selectCard(index, item)" class="form-check-input" type="radio" name="flexRadioDefault" :id="'flexRadioDefault' + index" :checked="selectedCardIndex === index">
                        <label @click="selectCard(index, item)" class="form-check-label" :for="'flexRadioDefault' + index">
                           <div class="paymentAccount-header">
                              <div class="paymentAccount-icon">
                                 <img loading="lazy" :src="item.icon?item.icon: require('@/assets/images/bank-img.webp')" alt="bank-icon">
                              </div>
                              <h6 class="paymentAccount-title">{{item.bank_name ? item.bank_name : item.payment_method }}</h6>
                              <button @click="selectedRemoveAcc = item; openDeleteModal()" class="delete-btn">
                                 <img loading="lazy" src="@/assets/images/remove-icon.svg" alt="remove-icon">
                              </button>
                           </div>
                           <div class="paymentAccount-body added-bank-details-wrapper">
                              <p class="paymentAccount-text">
                                 <span>{{$t('payment-type', 'Payment Type')}}</span>: <b>{{ item.payment_method }}</b>
                                 <span class="copy-btn-tool-tips-sec">
                                    <button class="copy-icon" @click="copyPaymentData($t('payment-type', 'Payment Type'), item.payment_type_name)">
                                       <img loading="lazy" src="@/assets/images/copy-icon.svg" alt="copy-icon">
                                    </button>
                                    <!-- <span class="copt_text_hover" v-if="copiedText == item.payment_method">
                                       {{ $t('copied', ' Copied') }}!
                                    </span> -->
                                 </span>
                              </p>
                              <p class="paymentAccount-text">
                                 <span>{{$t('account-holder-name', 'A/C Holder Name')}}</span>: <b>{{ item.account_holder_name }}</b>
                                 <span class="copy-btn-tool-tips-sec">
                                    <button class="copy-icon" @click="copyPaymentData($t('account-holder-name', 'A/C Holder Name'), item.account_holder_name)">
                                       <img loading="lazy" src="@/assets/images/copy-icon.svg" alt="copy-icon">
                                    </button>
                                    <!-- <span class="copt_text_hover" v-if="copiedText == item.account_holder_name">
                                       {{ $t('copied', ' Copied') }}!
                                    </span> -->
                                 </span>
                              </p>
                              <p class="paymentAccount-text">
                                 <span>{{ item?.ifsc_code ? $t('bank-name', 'Bank Name') :  $t('payment-method', 'Payment Method') }}</span>: <b>{{ item.method_name }}</b>
                                 <span class="copy-btn-tool-tips-sec">
                                    <button class="copy-icon" @click="copyPaymentData($t('bank-name', 'Bank Name'), item.method_name)">
                                       <img loading="lazy" src="@/assets/images/copy-icon.svg" alt="copy-icon">
                                    </button>
                                    <!-- <span class="copt_text_hover" v-if="copiedText == item.method_name">
                                       {{ $t('copied', ' Copied') }}!
                                    </span> -->
                                 </span>
                              </p>
                              <template v-if="item?.account_number">
                                 <p class="paymentAccount-text">
                                    <span>{{$t('account-number', 'Account Number')}}</span>: <b>{{ item?.account_number }}</b>
                                    <span class="copy-btn-tool-tips-sec">
                                       <button class="copy-icon" @click="copyPaymentData($t('account-number', 'Account Number'), item.account_number)">
                                          <img loading="lazy" src="@/assets/images/copy-icon.svg" alt="copy-icon">
                                       </button>
                                       <!-- <span class="copt_text_hover" v-if="copiedText == item?.account_number">
                                          {{ $t('copied', ' Copied') }}!
                                       </span> -->
                                    </span>
                                 </p>
                                 <p class="paymentAccount-text" v-if="item?.ifsc_code">
                                    <span>{{$t('ifsc', 'IFSC')}}</span>: <b>{{ item?.ifsc_code }}</b>
                                    <span class="copy-btn-tool-tips-sec">
                                       <button class="copy-icon" @click="copyPaymentData($t('ifsc', 'IFSC'), item.ifsc_code)">
                                          <img loading="lazy" src="@/assets/images/copy-icon.svg" alt="copy-icon">
                                       </button>
                                          <!-- <span class="copt_text_hover" v-if="copiedText == item?.ifsc_code">
                                             {{ $t('copied', ' Copied') }}!
                                          </span> -->
                                    </span>
                                 </p>
                              </template>
                              <template v-else>
                                 <p class="paymentAccount-text" v-if="item?.phone_number">
                                    <span>{{$t('phone-number', 'Phone Number')}} </span>: <b>{{ item?.phone_number }}</b>
                                    <span class="copy-btn-tool-tips-sec">
                                       <button class="copy-icon" @click="copyPaymentData($t('phone-number', 'Phone Number'), item.phone_number)">
                                          <img loading="lazy" src="@/assets/images/copy-icon.svg" alt="copy-icon">
                                       </button>
                                       <!-- <span class="copt_text_hover" v-if="copiedText == item?.phone_number">
                                          {{ $t('copied', ' Copied') }}!
                                       </span> -->
                                    </span>
                                 </p>
                                 <p class="paymentAccount-text" v-if="item?.upi_id || item?.crypto_wallet_id">
                                    <span>{{ item?.upi_id ? $t('upi-id', 'UPI Id'):$t('wallet-id', 'Wallet Id') }} </span>:
                                     <b>{{ item?.upi_id ? item?.upi_id : item?.crypto_wallet_id }}</b>
                                     <span class="copy-btn-tool-tips-sec">
                                       <button class="copy-icon" @click="copyPaymentData(item?.upi_id ? $t('wallet-id', 'Wallet Id') : $t('upi-id', 'UPI Id'), item?.upi_id ? item?.upi_id : item?.crypto_wallet_id)">
                                          <img loading="lazy" src="@/assets/images/copy-icon.svg" alt="copy-icon">
                                       </button>
                                       <!-- <span class="copt_text_hover" v-if="copiedText == item?.upi_id ? item?.upi_id : item?.wallet_id">
                                          {{ $t('copied', ' Copied') }}!
                                       </span> -->
                                    </span>
                                 </p>
                              </template>
                           </div>
                        </label>
                     </div>
                     
                  </div>
                  <div class="paymentAccount-nodata" v-if="accountsList && accountsList?.length == 0">
                        <span>Add Account To Withdraw...</span>
                     </div>
                  <div class="paymentAccount-nodata" v-if="searchAccount && filteredAccountList && filteredAccountList?.length == 0">
                     <span>No Bank Account Found</span>
                  </div>
                  <form class="withdrawalForm" v-if="accountsList && accountsList?.length > 0">
                     <div class="input-field">
                           <div class="d-flex justify-content-between align-items-center avil-bal-sec">
                              <label class="form-label">{{ $t('withdra-amount','Withdraw Amount')}}</label>
                              <label class="form-label">Available Balance: <span class="avil-balnace-text">{{withdrawlBalance}}</span></label>
                           </div>
                           <input class="form-control" type="tel" id="amount" maxlength="10" @input="amount = $helper.sanitizeNumber(+amount, +walletData?.withdrawal_range?.max || 99999999)" :placeholder="$t('enter-amount','Enter amount')" v-model="amount">
                           <div class="min-max-section">
                              <div class="min-max-con">
                                 <h6>{{$t('min', 'min')}} <span>{{ walletData?.withdrawal_range?.min }}</span></h6>
                              </div>
                              <div class="min-max-icon">
                                 <img src="@/assets/images/min-max-icon.svg" alt="max" loading="lazy">
                              </div>
                              <div class="min-max-con">
                                 <h6>{{$t('max', 'max')}} <span>{{ walletData?.withdrawal_range?.max }}</span></h6>
                              </div>
                           </div>
                     </div>
                     <!-- <button :class="{'btn-disabled' : amount < walletData?.range?.minimum_withdrawal }" type="button" class="withdrawBtn" @click="withdrawAmountFuncCall()">
                           {{ $t('withdraw', 'Withdraw') }}
                     </button> -->

                     <div class="withdraw-btn">
                           <a :class="{'btn-disabled' : amount < walletData?.withdrawal_range?.min }" @click="withdrawAmountFuncCall()" class="btnTheme-yellow w-100">
                              <span>{{$t('withdraw', 'Withdraw')}}</span>
                           </a>
                     </div>
                  </form>
                  <div class="forgotWithdraw-wrap">
                     <a href="javascript:void(0)" class="forgot--btn" @click="openWithdrawPasswordModal()">
                        {{$t('forgot-withdraw-password','Forgot Withdraw Password')}}?
                     </a> 
                  </div>
                  <WalletInstructions instructionType="withdrawal" />
                  <div class="mt-3">
                     <TutorialVideo type = "3" v-if="Object.values(walletConfig?.withdrawal_video).some(val => val?.trim() !== '')"/>
                  </div>
               </div>
            </section>


            <div class="modal fade modal-style" id="deletemodal" ref="close_btn" tabindex="-1"
                aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered"> 
                    <DeleteModal v-if="selectedRemoveAcc" @yes-click="removeAccountHere(),getAccountDetailsServiceCall()" @close="closeModal()" :item="selectedRemoveAcc" />

                </div>
            </div>
            

        </div>
        <Support></Support>
        
    </div>

    <!-- -----Add Account Modal ------ -->
    <AddBankAccount ref="addBankRef" :is_withdrawal_password_set="is_withdrawal_password_set"  @getAccountDetailList = "getAccountDetailsServiceCall()"/>
    <WithdrawalPasswordSetReset ref="withdrawSetReset" />
   
   
            <div class="modal fade modal-footer-sticky modalFix-bottom modal-style" id="checkWithdrawPassModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5  class="modal-title">{{$t('withDraw-password','Withdraw password')}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"><i class="fa-solid fa-xmark"></i></button>
                        </div>
                        <div class="modal-body">
                            <div class="account-delete-msg">
                                <p>{{$t('skip-msg','Withdraw password not set. Continue to add or skip')}}..!!</p>
                            </div>
                            <div class="header-but info-footer">
                               <button type="button" class="thm-but thm-bor-but" data-bs-dismiss="modal" @click="addAccountServiceCall(true)">{{$t('skip', 'Skip')}}</button>
                               <a class="thm-but" data-bs-dismiss="modal" :disabled="OTPloading" @click="openWithdrawPasswordModal()">{{$t('continue', 'Continue')}}</a>
                           </div>
                        </div>
                    </div>
                </div>
            </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import {openWithdrawPasswordModal} from '../services/withdrawAccountDetails';
import {getUserAccounts, withdrawWalletAmount, withdrawAmountClickValidation} from '../services/walletWithdraw';
import WalletInstructions from '../components/WalletInstructions.vue';
import TutorialVideo from '../components/TutorialVideo.vue';
import WithdrawalPasswordSetReset from '../components/WithdrawalPasswordSetReset.vue';
import AddBankAccount from '../components/AddBankAccount.vue';
import WalletHeader from '../components/WalletHeader.vue';
import DeleteModal from '../components/DeleteModal.vue';
import Support from '@/shared/components/support/Support.vue';
import EditStakeModal from '../components/EditStakeModal.vue';
export default {
    name: 'PaymentMethod',
    inject: ['walletConfig','onlyBank'],
    components: {
        EditStakeModal,
        Support,
        DeleteModal,
        WalletHeader,
        AddBankAccount,
        WithdrawalPasswordSetReset,
        TutorialVideo,
        WalletInstructions,
    },
   data() {
      return {
         is_withdrawal_password_set:false,
         loading: false,
         selectedRemoveAcc: null,
         selectedCardIndex: null,
         accountsList: [],
         amount: null,
         OTPloading: false,
         walletData: null,
         selectBankId: null,
         searchAccount:null,
         copiedText:'',
      }
   },
   computed:{
      filteredAccountList() {            
         if(this.searchAccount) {
               const searchTermLower = this.searchAccount?.toLowerCase();
               return this.accountsList.filter(item =>
                  item?.bank_name?.toLowerCase().includes(searchTermLower) ||
                  item?.payment_type_name?.toLowerCase().includes(searchTermLower) ||
                  item?.account_holder_name?.toLowerCase().includes(searchTermLower) ||
                  item?.account_number?.toLowerCase().includes(searchTermLower) ||
                  item?.upi_id?.toLowerCase().includes(searchTermLower) ||
                  item?.crypto_wallet_id?.toLowerCase().includes(searchTermLower)
               );
         }
         return this.accountsList
      },
      withdrawlBalance() {
         let { balance = 0, expl = 0 } = this.$auth?.user || {};
         let earnBonus = this.$auth.user.earnBonus || 0;
         return (parseFloat(balance) + parseFloat(expl || 0) - parseFloat(earnBonus)).toFixed(2);
      }
   },
   mounted() {
      if(this.$auth.user.isDemo){
         this.$errorToast("Wallet access is restricted for demo user");
         setTimeout(() => {
            this.$router.push({name: 'Home'})
         }, 500);
      }
      this.walletData = this.walletConfig;
      this.getAccountDetailsServiceCall();
      
   },
   methods: {
      async openWithdrawPasswordModal(){

            try{
                this.OTPloading = true;
                let response = await openWithdrawPasswordModal()
                this.OTPloading = false;
                if(!response?.error){
                  //   this.$refs.withdrawSetReset.assignWithdrawPhoneNumber(data.data.phone_no)
                    this.$helper.openModal('#withdrawalPassword');
                    this.$refs.withdrawSetReset.otpHasBeenCalled()
                    this.$refs.withdrawSetReset.resetTimer();
                }else{
                  //   this.$refs.addBankRef.addAccountServiceCall(true)
                    this.$errorToast(response?.error);
                }
            }
            catch(error){
                this.OTPloading = false;
                if(error) {
                    this.$errorToast(error);
                }
            }
      },
      addAccountServiceCall(){
         this.$refs.addBankRef.addAccountServiceCall(true);
      },
      openDeleteModal() {
			this.$nextTick(() => {
                this.$helper.openModal('#deletemodal')
			});
		},
      searchstart(){
         this.selectedCardIndex = 0;
         this.selectBankId = this.filteredAccountList?.[0]?.id;
      },
      selectCard(index, bankId) {
         this.selectedCardIndex = index;
         this.selectBankId = bankId.client_account_id;
      },
      async getAccountDetailsServiceCall(reconnectTry = 0){
            try{
                let response = await getUserAccounts(reconnectTry)
                this.accountsList = response.userAccounts
                if (this.accountsList.length > 0) {
                    this.selectedCardIndex = 0;
                    this.selectBankId = this.accountsList[0].client_account_id;
                }
            }
            catch(error){
                if(reconnectTry < 3 && !error) {
                    this.getAccountDetailsServiceCall(reconnectTry + 1);
                }
                else {
                    this.loading = false;
                    if (error) {
                      console.log("Error : ", error[0]);
                      this.$errorToast(error[0]);
                    }
                }

            }
        },
      capitalizeText(text){
         if(typeof text == 'string'){
               text = text.trim();
               return text.toLowerCase().split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
         }else
               return text
      },
      async copyPaymentData(catagory, accountData) {
         try {
               await navigator.clipboard.writeText(accountData);
               this.copiedText = accountData;
               this.$successToast(this.capitalizeText(catagory +' '+'Copied Successfully'))
               setTimeout(() => {
                    this.copiedText = null;
                    document.querySelectorAll('copy-icon').forEach(el => {
                        el.style.color = '#000000';
                    });
                }, 1000);
         } catch (err) {
               console.error(this.capitalizeText('Failed to copy'));
         }
      },
      withdrawAmountFuncCall() {
         const minAmount = this.walletData?.range?.minimum_withdrawal || 100; 
         const maxAmount = this.walletData?.range?.maximum_withdrawal || 99999999; 
         if (this.amount == null || parseFloat(this.amount) < minAmount || parseFloat(this.amount) > maxAmount) {
               this.$errorToast(`${this.$t('please-enter-an-amount-between', 'Please enter an amount between')} ${this.minAmount} and ${this.maxAmount}.`);
         } else {
               this.withdrawAmountServiceCall();
         }
      },

      async withdrawAmountServiceCall() {
            let isValid = await withdrawAmountClickValidation(this.amount, this.walletConfig, this.withdrawlBalance);
            if (isValid) {
                this.$store.dispatch('setGlobalLoader', true);
                let response = await withdrawWalletAmount(this.amount, this.selectBankId);
                this.$store.dispatch('setGlobalLoader', false);
                if (!response?.error) {
                    this.$router.push({ name: 'Home' })
                } else {
                    console.error('Withdrawal error:', response.error);
                }
            }
		},
      removeAccountHere() {
         let index = this.accountsList.indexOf(this.selectedRemoveAcc);
         this.accountsList.splice(index, 1);
         this.closeModal();
      },
      closeModal() {
         this.selectedRemoveAcc = null;
         this.$refs.close_btn.click();
      },
   }

}
</script>

<style></style>